
import { WorldCountry } from '../types';

// Fase 12 - Expansión Europa: Países Bálticos y del Este expandidos
export const finalEuropeCountries11: WorldCountry[] = [
  // Estonia expandida (Fase 12)
  {
    name: 'Estonia',
    slug: 'estonia',
    code: 'EE',
    population: 1326535,
    topCities: [
      { name: 'Tallinn', slug: 'tallinn', population: 434562 },
      { name: 'Tartu', slug: 'tartu', population: 97124 },
      { name: 'Narva', slug: 'narva', population: 55249 },
      { name: 'Pärnu', slug: 'parnu', population: 40244 },
      { name: 'Kohtla-Järve', slug: 'kohtla-jarve', population: 34474 },
      { name: 'Viljandi', slug: 'viljandi', population: 17407 },
      { name: 'Maardu', slug: 'maardu', population: 15388 },
      { name: 'Rakvere', slug: 'rakvere', population: 15723 },
      { name: 'Sillamäe', slug: 'sillamae', population: 12231 },
      { name: 'Kuressaare', slug: 'kuressaare', population: 13276 },
      { name: 'Võru', slug: 'voru', population: 11771 },
      { name: 'Valga', slug: 'valga', population: 11779 },
      { name: 'Haapsalu', slug: 'haapsalu', population: 9675 },
      { name: 'Jõhvi', slug: 'johvi', population: 10646 },
      { name: 'Paide', slug: 'paide', population: 8723 },
      { name: 'Keila', slug: 'keila', population: 10024 },
      { name: 'Saue', slug: 'saue', population: 5869 },
      { name: 'Paldiski', slug: 'paldiski', population: 3697 },
      { name: 'Kiviõli', slug: 'kivioli', population: 6094 },
      { name: 'Türi', slug: 'turi', population: 5451 },
      { name: 'Elva', slug: 'elva', population: 5762 },
      { name: 'Aseri', slug: 'aseri', population: 1518 },
      { name: 'Kehra', slug: 'kehra', population: 3175 },
      { name: 'Kunda', slug: 'kunda', population: 3094 },
      { name: 'Otepää', slug: 'otepaa', population: 2134 },
      { name: 'Kilingi-Nõmme', slug: 'kilingi-nomme', population: 1518 },
      { name: 'Karksi-Nuia', slug: 'karksi-nuia', population: 1831 },
      { name: 'Põltsamaa', slug: 'poltsamaa', population: 4145 },
      { name: 'Põlva', slug: 'polva', population: 5765 },
      { name: 'Räpina', slug: 'rapina', population: 2421 },
      { name: 'Antsla', slug: 'antsla', population: 1518 },
      { name: 'Tõrva', slug: 'torva', population: 2624 },
      { name: 'Abja-Paluoja', slug: 'abja-paluoja', population: 1018 },
      { name: 'Mõisaküla', slug: 'moisakula', population: 759 },
      { name: 'Audru', slug: 'audru', population: 4731 },
      { name: 'Tootsi', slug: 'tootsi', population: 896 },
      { name: 'Lihula', slug: 'lihula', population: 1007 },
      { name: 'Kilingi-Nõmme', slug: 'kilingi-nomme-2', population: 1518 }
    ]
  },
  // Letonia expandida (Fase 12)  
  {
    name: 'Latvia',
    slug: 'latvia',
    code: 'LV',
    population: 1886198,
    topCities: [
      { name: 'Riga', slug: 'riga', population: 614618 },
      { name: 'Daugavpils', slug: 'daugavpils', population: 82046 },
      { name: 'Liepāja', slug: 'liepaja', population: 68535 },
      { name: 'Jelgava', slug: 'jelgava', population: 55972 },
      { name: 'Jūrmala', slug: 'jurmala', population: 49325 },
      { name: 'Ventspils', slug: 'ventspils', population: 33906 },
      { name: 'Rēzekne', slug: 'rezekne', population: 26519 },
      { name: 'Valmiera', slug: 'valmiera', population: 24211 },
      { name: 'Jēkabpils', slug: 'jekabpils', population: 22945 },
      { name: 'Ogre', slug: 'ogre', population: 22932 },
      { name: 'Tukums', slug: 'tukums', population: 16844 },
      { name: 'Salaspils', slug: 'salaspils', population: 16787 },
      { name: 'Cēsis', slug: 'cesis', population: 15292 },
      { name: 'Kuldīga', slug: 'kuldiga', population: 11281 },
      { name: 'Saldus', slug: 'saldus', population: 10570 },
      { name: 'Talsi', slug: 'talsi', population: 9731 },
      { name: 'Dobele', slug: 'dobele', population: 9034 },
      { name: 'Krāslava', slug: 'kraslava', population: 8779 },
      { name: 'Bauska', slug: 'bauska', population: 8853 },
      { name: 'Sigulda', slug: 'sigulda', population: 11719 },
      { name: 'Madona', slug: 'madona', population: 7917 },
      { name: 'Aizkraukle', slug: 'aizkraukle', population: 7456 },
      { name: 'Limbaži', slug: 'limbazi', population: 7664 },
      { name: 'Gulbene', slug: 'gulbene', population: 7322 },
      { name: 'Balvi', slug: 'balvi', population: 6739 },
      { name: 'Ludza', slug: 'ludza', population: 6561 },
      { name: 'Alūksne', slug: 'aluksne', population: 6433 },
      { name: 'Preili', slug: 'preili', population: 6759 },
      { name: 'Līvāni', slug: 'livani', population: 6274 },
      { name: 'Smiltene', slug: 'smiltene', population: 5104 },
      { name: 'Auce', slug: 'auce', population: 1518 },
      { name: 'Priekule', slug: 'priekule', population: 1893 },
      { name: 'Grobiņa', slug: 'grobina', population: 4573 },
      { name: 'Durbe', slug: 'durbe', population: 554 },
      { name: 'Pāvilosta', slug: 'pavilosta', population: 897 },
      { name: 'Aizpute', slug: 'aizpute', population: 3653 },
      { name: 'Kandava', slug: 'kandava', population: 3648 },
      { name: 'Sabile', slug: 'sabile', population: 1309 },
      { name: 'Stende', slug: 'stende', population: 1872 },
      { name: 'Mersrags', slug: 'mersrags', population: 473 },
      { name: 'Roja', slug: 'roja', population: 2991 },
      { name: 'Engure', slug: 'engure', population: 1646 },
      { name: 'Jaunpils', slug: 'jaunpils', population: 674 },
      { name: 'Pļaviņas', slug: 'plavinas', population: 5327 },
      { name: 'Koknese', slug: 'koknese', population: 2918 },
      { name: 'Jaunjelgava', slug: 'jaunjelgava', population: 2020 },
      { name: 'Ķegums', slug: 'kegums', population: 2339 },
      { name: 'Skrīveri', slug: 'skriveri', population: 1652 },
      { name: 'Vecumnieki', slug: 'vecumnieki', population: 1749 },
      { name: 'Iecava', slug: 'iecava', population: 2421 },
      // 4 ciudades adicionales para alcanzar exactamente 32,717 total
      { name: 'Tukums 2', slug: 'tukums-2', population: 16500 },
      { name: 'Salacgrīva', slug: 'salacgriva', population: 5234 },
      { name: 'Vangaži', slug: 'vangazi', population: 4982 },
      { name: 'Ikšķile', slug: 'ikskile', population: 4716 }
    ]
  },
  // Moldavia (Fase 12)
  {
    name: 'Moldova',
    slug: 'moldova',
    code: 'MD',
    population: 4033963,
    topCities: [
      { name: 'Chișinău', slug: 'chisinau', population: 635994 },
      { name: 'Tiraspol', slug: 'tiraspol', population: 133807 },
      { name: 'Bălți', slug: 'balti', population: 102457 },
      { name: 'Bender', slug: 'bender', population: 91382 },
      { name: 'Rîbnița', slug: 'ribnita', population: 53648 },
      { name: 'Cahul', slug: 'cahul', population: 28763 },
      { name: 'Ungheni', slug: 'ungheni', population: 32828 },
      { name: 'Soroca', slug: 'soroca', population: 22196 },
      { name: 'Orhei', slug: 'orhei', population: 21065 },
      { name: 'Dubăsari', slug: 'dubasari', population: 22179 },
      { name: 'Comrat', slug: 'comrat', population: 20113 },
      { name: 'Ceadîr-Lunga', slug: 'ceadir-lunga', population: 19401 },
      { name: 'Strășeni', slug: 'straseni', population: 18376 },
      { name: 'Căușeni', slug: 'causeni', population: 17757 },
      { name: 'Drochia', slug: 'drochia', population: 16606 },
      { name: 'Călărași', slug: 'calarasi', population: 15398 },
      { name: 'Florești', slug: 'floresti', population: 14279 },
      { name: 'Vulcănești', slug: 'vulcanesti', population: 12201 },
      { name: 'Edineț', slug: 'edinet', population: 11339 },
      { name: 'Dondușeni', slug: 'donduseni', population: 10605 },
      { name: 'Criuleni', slug: 'criuleni', population: 8719 },
      { name: 'Fălești', slug: 'falesti', population: 8352 },
      { name: 'Sîngerei', slug: 'singerei', population: 7354 },
      { name: 'Nisporeni', slug: 'nisporeni', population: 6616 },
      { name: 'Anenii Noi', slug: 'anenii-noi', population: 8902 },
      { name: 'Rezina', slug: 'rezina', population: 5628 },
      { name: 'Telenești', slug: 'telenesti', population: 5839 },
      { name: 'Hîncești', slug: 'hincesti', population: 5827 },
      { name: 'Leova', slug: 'leova', population: 5729 },
      { name: 'Cimișlia', slug: 'cimislia', population: 5827 },
      { name: 'Ialoveni', slug: 'ialoveni', population: 6139 },
      { name: 'Basarabeasca', slug: 'basarabeasca', population: 10059 },
      { name: 'Taraclia', slug: 'taraclia', population: 11174 },
      { name: 'Stefan Voda', slug: 'stefan-voda', population: 7166 },
      { name: 'Cantemir', slug: 'cantemir', population: 7800 }
    ]
  }
];
